import { baseClient } from '../common';
import { ItemModel } from './item.model';
import { ItemStatsModel, ItemStatsQueryModel } from './item-stats.model';
import { UpdateItemStatusModel } from './update-item-status.model';

export const itemClient = {
  list: (shopId: string): Promise<ItemModel[]> => {
    return baseClient.get<ItemModel[]>(`/api/shops/${shopId}/items`);
  },

  stats: (
    shopId: string,
    query: ItemStatsQueryModel,
  ): Promise<ItemStatsModel[]> => {
    const params = new URLSearchParams();

    if (query.from) {
      params.set('from', query.from);
    }

    if (query.to) {
      params.set('to', query.to);
    }

    if (query.placeIds?.length) {
      params.set('placeIds', query.placeIds.join(','));
    }

    // Not `params.size`: older WebViews lack it, which would drop every filter.
    const queryString = params.toString();
    const search = queryString ? `?${queryString}` : '';

    return baseClient.get<ItemStatsModel[]>(
      `/api/shops/${shopId}/item-stats${search}`,
    );
  },

  updateStatus: (
    key: string,
    model: UpdateItemStatusModel,
  ): Promise<ItemModel> => {
    return baseClient.body<UpdateItemStatusModel, ItemModel>({
      body: model,
      method: 'PUT',
      url: `/api/items/${key}`,
    });
  },
};
